import { Carousel, CarouselProps } from 'antd';

import Section from 'layouts/Section/Section';

import { ReactComponent as ArrowLeft } from 'assets/icons/arrowLeftClean.svg';
import { ReactComponent as ArrowRight } from 'assets/icons/arrowRightClean.svg';

import styles from './OurCLients.module.scss';
import items from './items';

const OurCLients = () => {
  return (
    <Section>
      <Carousel
        responsive={[
          { breakpoint: 1200, settings: { slidesToShow: 4 } },
          { breakpoint: 810, settings: { slidesToShow: 2 } },
          { breakpoint: 520, settings: { slidesToShow: 1 } }
        ]}
        slidesToShow={6}
        className="clients-carousel"
        arrows
        nextArrow={<ArrowRight />}
        prevArrow={<ArrowLeft />}
        autoplaySpeed={4000}
        infinite
      >
        {items.map((url) => (
          <div className={styles.imageContainer}>
            <img className={styles.image} src={url} />
          </div>
        ))}
      </Carousel>
    </Section>
  );
};

export default OurCLients;
